<!-- 联盟成员的内部管理人员列表 -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">审核状态</div>
                <el-select class="search-item" size="small" v-model="searchData.State">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">纠错时间</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="handleChange"
                    size="small"
                    class="search-name"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                    <el-table-column min-width="120px" prop="APCode" label="配件编码" show-overflow-tooltip> </el-table-column>
                    <el-table-column min-width="120px" prop="GoodName" label="配件名称" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="200px" prop="Remark" label="纠错内容" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="CorrectTime" label="纠错时间" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" prop="EntpName" label="来自联盟成员" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100px" prop="Corrector" label="纠错人" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" prop="StateName" label="审核状态" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" prop="Checker" label="审核人" show-overflow-tooltip
                        ><template slot-scope="scope">
                            {{ scope.row.CheckState == 0 ? '-' : scope.row.Checker }}
                        </template></el-table-column
                    >
                    <el-table-column width="160px" prop="CheckTime" label="审核时间" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.CheckTime == '1900-01-01 00:00:00' || scope.row.CheckState == 0 ? '-' : scope.row.CheckTime }}
                        </template></el-table-column
                    >
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="showCorrectAPMsgDialog(scope.row.CorrectId)" v-if="permission.check && scope.row.CheckState == 0">{{
                                    permission.check
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <RecorrectUnionAPMsg
                v-if="recorrectAPMsgVisible"
                :dialogFormVisible="recorrectAPMsgVisible"
                :SType="1"
                :CorrectId="correctId"
                @closeDialog="closeRecorrectAPMsgDialog"
            ></RecorrectUnionAPMsg>
        </template>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import RecorrectUnionAPMsg from '@/components/entpUnion/goodsManage/recorrectUnionAPMsg.vue';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'correctionCheck',
    components: {
        elTableColumn,
        breadcrumb,
        RecorrectUnionAPMsg
    },
    data() {
        return {
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未审核', Value: '0' },
                { Text: '已纠正', Value: '1' },
                { Text: '已忽略', Value: '2' }
            ],
            recorrectAPMsgVisible: false,
            dateTimes: '',
            correctId: '',
            loading: false,
            noData: false,
            tableData: [],
            tableDataLength: 0,
            permission: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getUnionPermission('CorrectionCheck');
        this.getTableData();
    },
    methods: {
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            };
            this.dateTimes =[];
        },
        // 获取数据
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetUnionGoodsCorrectList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        removeOut(item) {
            let that = this;
            if (item.StaffId) {
                that.$confirm('您确定要将【' + item.StaffName + '】移出联盟吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnions/RemoveOutUnionStaffs',
                                data: {
                                    UnionId: that.searchData.UnionId,
                                    StaffId: item.StaffId
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg('成功移出联盟');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        showCorrectAPMsgDialog(id) {
            if (id) {
                this.correctId = id;
                this.recorrectAPMsgVisible = true;
            }
        },
        closeRecorrectAPMsgDialog(edit) {
            if (edit) this.getTableData();
            this.recorrectAPMsgVisible = false;
        }
    }
};
</script>
